<template>
    <v-card
        style="position: relative; height: 100%; background: #f5f5f5"
        class="addSummaries"
    >
        <v-overlay absolute :opacity="0.5" z-index="100000" v-if="loading">
            <v-progress-circular indeterminate size="64">
                {{ $t("loading") }}
            </v-progress-circular>
        </v-overlay>
        <v-form>
            <v-toolbar
                flat
                dark
                :class="screen === 'mobile' ? '' : 'pr-10 pl-10'"
                color="#2196F3"
            >
                <v-toolbar-title>
                    {{ $t("modals.summariesPopup.title") }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$emit('popup_close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container
                class="pt-5"
                :class="screen === 'mobile' ? '' : 'pr-15 pl-15 pt-0'"
            >
                <v-card flat style="background: transparent">
                    <v-card-subtitle class="summariesPopup__subtitle">{{
                        $t("modals.summariesPopup.createNew")
                    }}</v-card-subtitle>
                    <v-text-field
                        full-width
                        v-model="createInput"
                        background-color="white"
                        class="text-input"
                        v-on:keydown.enter="addSummaries"
                    />
                    <v-btn
                        color="#2196F3"
                        class="submit"
                        @click="addSummaries"
                        style="margin-left: auto; display: block"
                    >
                        {{ $t("modals.summariesPopup.create") }}
                    </v-btn>
                </v-card>
            </v-container>
        </v-form>
    </v-card>
</template>
<script>
export default {
    name: "addSummariesPopup",
    props: {
        screen: String,
        scrlSet: Object,
    },
    data: () => ({
        tab: null,
        summariesList: [],
        dragGroupName: "draggableArea",
        loading: true,
        createInput: "",
    }),
    mounted() {
        this.loading = false;
        if (this.getterSummariesList) {
            this.summariesList = this.getterSummariesList;
        }
    },
    methods: {
        addSummaries() {
            if (this.createInput.length === 0) {
                return this.$toastr.warning(
                    this.$t("messages.addSummariesName")
                );
            }
            this.loading = true;
            console.log(q);

            let q = this.summariesList.find((item) => {
                return item.name === this.createInput;
            });
            if (q) {
                this.loading = false;
                return this.$toastr.warning(
                    this.$t("messages.existingSummary")
                );
            } else {
                let data = {
                    digestName: this.createInput,
                };

                this.$store.dispatch("AddSummaries", data);
            }
            this.loading = false;
            this.$emit("reload");
            this.$emit("popup_close");
        },

        /**
         * download file func
         * */
        getArticlesId() {
            return this.articles.map((article) => article.id);
        },
    },
    computed: {
        getterSummariesList() {
            return this.$store.getters.summariesList;
        },
        updateCurrentList() {
            this.summariesList = this.getterSummariesList;
        },
    },
};
</script>
<style scoped lang="scss">
.v-tab {
    background: transparent;
    color: #2196f3 !important;
    z-index: 2;
    &--active {
        color: #fff !important;
    }
}
.v-tabs-items {
    width: 100%;
}
.submit {
    color: #fff !important;
}
.summariesPopup__subtitle {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    font-family: Roboto;
    color: #757575;
    padding: 8px 0 0;
}
.pl-15.pr-15 {
    padding: 15px 30px !important;
}
.pl-10.pr-10 {
    padding-left: 15px !important;
    padding-right: 15px !important;
    .v-toolbar__content {
        padding: 0 !important;
    }
}
.text-input {
    border-radius: 5px;
    padding: 0 15px !important;
    background: #fff;
    height: 68px !important;
    margin: 15px 0;
}
</style>